import { useEffect, useRef } from "react"
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  headingsPlugin,
  // imagePlugin,
  // InsertImage,
  listsPlugin,
  ListsToggle,
  markdownShortcutPlugin,
  MDXEditor,
  MDXEditorMethods,
  Separator,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo,
} from "@mdxeditor/editor"
import classNames from "classnames"

import "assets/libs/markdown.css"

// import resizeImageWithDataUrl from "utils/resizeImageWithDataUrl"
// import CustomImageUpload from "./CustomImageUpload"
import styles from "./index.module.scss"

interface Props {
  errorMessage?: string
  value: string
  id?: string
  onChange?: (message_rich: string, message: string) => void
}

export const MarkdownEditor = ({ errorMessage, value, onChange }: Props) => {
  const editorRef = useRef<MDXEditorMethods>(null)

  const handleSetMarkdown = (markdown: string) => {
    if (editorRef.current) {
      editorRef.current.setMarkdown(markdown)
    }
  }

  const handleChange = (message_rich: string) => {
    const message = message_rich
      .replace(/!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/g, "")
      .replace(/<img [^>]*>/g, "")

    onChange?.(message_rich, message)
  }

  // const handleImageUpload = async (file: File): Promise<string> => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader()

  //     reader.onload = e => {
  //       resizeImageWithDataUrl({
  //         dataUrl: e.target?.result as string,
  //         keepRatio: true,
  //       }).then((resizedBase64: string) => {
  //         resolve(resizedBase64)
  //       })
  //     }

  //     reader.onerror = error => reject(error)
  //     reader.readAsDataURL(file)
  //   })
  // }

  useEffect(() => {
    handleSetMarkdown(value)
  }, [value])

  useEffect(() => {
    const styleElement = document.createElement("style")
    styleElement.innerHTML = `
      .${styles.editor} img {
        max-width: 250px !important;
      }
    `

    document.head.appendChild(styleElement)

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  return (
    <>
      <MDXEditor
        ref={editorRef}
        onChange={handleChange}
        contentEditableClassName={classNames(styles.editor, { [styles.error]: errorMessage })}
        markdown={value}
        placeholder="Type your text..."
        plugins={[
          headingsPlugin(),
          listsPlugin(),
          tablePlugin(),
          thematicBreakPlugin(),
          markdownShortcutPlugin(),
          // imagePlugin({
          //   imageUploadHandler: handleImageUpload,
          //   imageAutocompleteSuggestions: [],
          //   disableImageSettingsButton: true,
          // }),
          toolbarPlugin({
            toolbarContents: () => (
              <>
                <UndoRedo />
                <BoldItalicUnderlineToggles />
                <Separator />
                <ListsToggle options={["bullet", "number"]} />
                <BlockTypeSelect />
                <Separator />
                {/* <InsertImage /> */}
                {/* <CustomImageUpload /> */}
              </>
            ),
          }),
        ]}
      />
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
    </>
  )
}
